export default {
  supplyAndDemandLong:[
		'0 items',
		'1-30 items',
		'31-60 items',
		'60+ items'
  ],
  supplyAndDemandShort:[
    '0',
    '1-30',
    '31-60',
    '60+',
  ]
}